import React from "react";
import {
  Container,
  Tabs,
  Tab,
  Spinner,
  Modal,
  OverlayTrigger,
  Tooltip,
  Button,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleLeft,
  faCircle,
  faCloudArrowDown,
  faShareNodes,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import "./HiringProcessDashboard.scss";
import ApplicantProfile from "./ApplicantProfile";
import HiringProcess from "./HiringProcess";
import Evaluation from "./Evaluation";
import InterviewVideosStats from "./InterviewVideosStats";
import useHiringProcessDashboard from "./useHiringProcessDashboard";
import { pdfjs } from "react-pdf";
import { getRating } from "../../../_helpers/getRating";
import CustomPdfViewer from "../../Common/CustomPdfViewer";
import MainLayout from "../../Common/MainLayout";
import useCopyToClipboard from "../../../_hooks/useCopyToClipboard";
import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  const {
    scheduleInterviewModal,
    calendarEventLists,
    userProfileInfo,
    userPrimarySkills,
    loading,
    applicantHmsVideos,
    userData,

    onNavigateBack,
    onScheduleInterviewClick,
    setLastElement,
    onAssignInterviewEventClick,
    onEventEditClick,
    onCreateEventClick,
    getJoineesNames,
  } = useHiringProcessDashboard(props);

  const { copyToClipboard } = useCopyToClipboard();
  return (
    <MainLayout pageName="Applicant Dashboard">
      <div className="hiring-process-dashboard footer-gap">
        <Container className="d-flex align-items-center justify-content-between py-2">
          <div className="d-flex align-items-center">
            <FontAwesomeIcon
              icon={faAngleLeft}
              className="font-weight-medium cursor-pointer text-primary"
              onClick={() => onNavigateBack()}
            />
            {loading ? null : (
              <h2 className="text-capitalize ml-2">
                {userProfileInfo?.candidate_details?.full_name}
              </h2>
            )}
          </div>
          <div className="d-flex align-items-center justify-content-between">
            <div className="share">
              <button
                className="btn btn-light mr-2"
                onClick={() =>
                  copyToClipboard(
                    "/view-candidate-profile",
                    userProfileInfo?.candidate_details &&
                    userProfileInfo.candidate_details?.hash_id
                  )
                }
              >
                <FontAwesomeIcon icon={faShareNodes} className="mr-2" />
                Share
              </button>
            </div>
            {userData?.role === "hiring_manager" &&
              userProfileInfo?.interview_stage === "interview" ? (
              <button
                className="btn btn-primary mr-2"
                onClick={onScheduleInterviewClick}
              >
                <FontAwesomeIcon icon={faCheck} className="mr-2" />
                Assign an Event
              </button>
            ) : null}
          </div>
        </Container>
        <div className="hiring-board pt-4">
          <div className="container">
            <div className="row no-gutters">
              {loading ? (
                <div className="d-flex justify-content-center align-items-center w-100">
                  <Spinner animation="border" variant="primary" />
                </div>
              ) : (
                <>
                  <div className="candidate-info-sidebar bg-white border border-radius-10 col-lg-4 col-xl-3">
                    <div className="p-3">
                      <div className="mb-2 w-100 d-flex align-items-center text-lg-center text-xl-left flex-lg-column flex-xl-row">
                        <div className="candidate-img rounded-lg">
                          <img
                            src={
                              userProfileInfo?.candidate_profile_details &&
                                userProfileInfo.candidate_profile_details
                                  ?.user_details &&
                                userProfileInfo.candidate_profile_details
                                  .user_details?.user_meta_info &&
                                userProfileInfo.candidate_profile_details
                                  .user_details.user_meta_info?.profile_image ===
                                null
                                ? "/assets/images/user.png"
                                : userProfileInfo?.candidate_profile_details &&
                                userProfileInfo.candidate_profile_details
                                  ?.user_details &&
                                userProfileInfo.candidate_profile_details
                                  .user_details?.user_meta_info &&
                                userProfileInfo.candidate_profile_details
                                  .user_details.user_meta_info?.profile_image
                            }
                            alt="candidate img"
                            className="profile-image "
                          />
                        </div>
                        <div className="candidate-quick-info  ml-3 ml-lg-0 ml-xl-3">
                          <h3 className="text-capitalize pt-2">
                            {userProfileInfo?.candidate_details?.full_name}
                          </h3>
                          <p className="text-capitalize text-grey-4 pt-2">
                            {userProfileInfo?.candidate_details?.headline}
                          </p>
                          {
                            Array.isArray(userProfileInfo?.candidate_profile_details &&
                              userProfileInfo.candidate_profile_details?.skills
                            ) &&
                              userProfileInfo.candidate_profile_details &&
                              userProfileInfo.candidate_profile_details?.skills
                              &&
                              userProfileInfo.candidate_profile_details.skills
                                .length !== 0 ? (
                              <span className="font-weight-medium mb-3 d-inline-block bg-grey rounded-pill pl-2 pr-1 py-1 border text-lg-center text-xxl-left">
                                Overall Rating
                                <OverlayTrigger
                                  overlay={
                                    <Tooltip>self evaluated skills</Tooltip>
                                  }
                                >
                                  <Button variant="white" className="p-0">
                                    <span className="overall-rating p-2 rounded-pill custom-tag tag-offer ml-2">
                                      <FontAwesomeIcon
                                        icon={faStar}
                                        className="mr-1"
                                      />
                                      <span className="text-danger fs-14">
                                        {userProfileInfo?.candidate_profile_details &&
                                          userProfileInfo
                                            .candidate_profile_details?.skills &&
                                          getRating(
                                            userProfileInfo?.candidate_profile_details &&
                                            userProfileInfo
                                              .candidate_profile_details?.skills
                                          )}
                                      </span>
                                    </span>
                                  </Button>
                                </OverlayTrigger>
                              </span>
                            ) : null}
                        </div>
                      </div>

                      <h4 className="mb-2 font-weight-medium mt-3">
                        Applied job
                      </h4>
                      <div className="candidate-quick-info mb-2 border-top mb-3 pt-2">
                        <h3 className="text-capitalize font-weight-medium">
                          {userProfileInfo?.job_details?.title}
                        </h3>
                        <p className="text-grey-4 mt-1">
                          {userProfileInfo?.job_details?.company_industry}{" "}
                          <span className="employment-type text-capitalize d-inline-block">
                            <FontAwesomeIcon
                              icon={faCircle}
                              className="fs-6 mr-2 ml-2 mb-1"
                            />
                            {userProfileInfo?.job_details &&
                              userProfileInfo.job_details?.employment_type?.replace(
                                /_/g,
                                "-"
                              )}
                          </span>
                        </p>
                      </div>
                      {Array.isArray(applicantHmsVideos) &&
                        applicantHmsVideos.length && (
                          <div className="action w-100 mt-1 label-voilet p-2 rounded-lg text-center">
                            <span className="mb-1">
                              {" "}
                              Interview{" "}
                              {applicantHmsVideos[0]?.room_videos &&
                                applicantHmsVideos[0].room_videos.length
                                ? "completed"
                                : "scheduled"}{" "}
                              between{" "}
                              {getJoineesNames(applicantHmsVideos[0])[0]} and{" "}
                              {getJoineesNames(applicantHmsVideos[0])[1]}
                            </span>
                          </div>
                        )}
                    </div>

                    {/* evaluation list  */}
                    <div className="evaluation-list border-top pt-2 d-none d-lg-block">
                      {userPrimarySkills &&
                        Array.isArray(userPrimarySkills) &&
                        userPrimarySkills.map((item) => (
                          <div className="" key={item?.id}>
                            {/* evaluation box  */}
                            <div className="evaluation-box py-3 px-2 bg-white rounded shadow-sm mb-2">
                              <div className="d-flex align-items-center justify-content-between">
                                <p className="text-capitalize fs-14 bg-grey rounded px-1">
                                  {item?.skill_name}
                                </p>
                                <span className="d-inline-block border rounded text-primary px-2">
                                  <FontAwesomeIcon
                                    icon={faStar}
                                    className="mr-2 text-warning"
                                  />
                                  {item?.rating}
                                </span>
                              </div>
                              <ul className="d-flex evaluation-ratings align-items-center mt-3">
                                {item?.rating
                                  ? [...Array(item?.rating).keys()].map(() => (
                                    <li className="bg-light">
                                      <span
                                        className="d-inline-block bg-primary h-100"
                                        style={{ width: "100%" }}
                                      ></span>
                                    </li>
                                  ))
                                  : null}
                                {[...Array(5 - item?.rating).keys()].map(
                                  (i) => (
                                    <li className="bg-light">
                                      <span
                                        className="d-inline-block bg-primary h-100"
                                        style={{ width: "0%" }}
                                      ></span>
                                    </li>
                                  )
                                )}
                              </ul>
                            </div>

                            {/* evaluation box ends */}
                          </div>
                        ))}
                    </div>

                    {/* evaluation box ends */}
                  </div>
                  <div className="col-lg-8 col-xl-9">
                    <div className="panel-right pt-3 ">
                      {userProfileInfo?.interview_stage === "applied" ? (
                        <Tabs
                          defaultActiveKey="ApplicantProfile"
                          className="border-bottom ml-md-4"
                        >
                          <Tab
                            eventKey="ApplicantProfile"
                            title="Applicant Profile"
                          >
                            <div className="tab-inner bg-grey-3 py-4 px-lg-4">
                              <ApplicantProfile />
                            </div>
                          </Tab>

                          <Tab
                            eventKey="HiringProgress"
                            title="Hiring Progress"
                          >
                            <div className="tab-inner pt-4 px-lg-4 bg-grey-3">
                              <HiringProcess />
                            </div>
                          </Tab>
                          <Tab eventKey="Resume" title="Resume">
                            <div className="tab-inner pt-4 px-lg-4 bg-grey-3 h-100">
                              {userProfileInfo?.candidate_profile_details &&
                                userProfileInfo.candidate_profile_details
                                  ?.user_details &&
                                userProfileInfo.candidate_profile_details
                                  .user_details?.user_meta_info &&
                                userProfileInfo.candidate_profile_details
                                  .user_details.user_meta_info?.resume ===
                                null ? (
                                <img
                                  src="/assets/images/resume-template.png"
                                  className="w-100"
                                  alt="resume template"
                                />
                              ) : (
                                <CustomPdfViewer
                                  file={
                                    userProfileInfo?.candidate_profile_details &&
                                    userProfileInfo.candidate_profile_details
                                      ?.user_details &&
                                    userProfileInfo.candidate_profile_details
                                      .user_details?.user_meta_info &&
                                    userProfileInfo.candidate_profile_details
                                      .user_details.user_meta_info?.resume
                                  }
                                />
                              )}
                            </div>
                          </Tab>
                          <Tab
                            eventKey="InterviewVideos"
                            title="Interview Videos"
                          >
                            <div className="tab-inner pt-4 px-lg-4 bg-grey-3">
                              <InterviewVideosStats />
                            </div>
                          </Tab>

                          <Tab eventKey="Evaluation" title="Evaluation">
                            <div className="tab-inner pt-4 px-lg-4 bg-grey-3">
                              <Evaluation
                                userPrimarySkills={userPrimarySkills}
                                overallRatings={
                                  userProfileInfo?.candidate_profile_details &&
                                  userProfileInfo.candidate_profile_details
                                    ?.skills &&
                                  getRating(
                                    userProfileInfo?.candidate_profile_details &&
                                    userProfileInfo.candidate_profile_details
                                      ?.skills
                                  )
                                }
                              />
                            </div>
                          </Tab>
                        </Tabs>
                      ) : (
                        <Tabs
                          defaultActiveKey="InterviewVideos"
                          className="border-bottom ml-md-4"
                        >
                          <Tab
                            eventKey="InterviewVideos"
                            title="Interview Videos"
                          >
                            <div className="tab-inner pt-4 px-lg-4 bg-grey-3">
                              <InterviewVideosStats />
                            </div>
                          </Tab>
                          <Tab
                            eventKey="HiringProgress"
                            title="Hiring Progress"
                          >
                            <div className="tab-inner pt-4 px-lg-4 bg-grey-3">
                              <HiringProcess
                                onScheduleInterviewClick={
                                  onScheduleInterviewClick
                                }
                                applicantHmsVideos={applicantHmsVideos}
                                getJoineesNames={getJoineesNames}
                              />
                            </div>
                          </Tab>
                          <Tab eventKey="Evaluation" title="Evaluation">
                            <div className="tab-inner pt-4 px-lg-4 bg-grey-3">
                              <Evaluation
                                userPrimarySkills={userPrimarySkills}
                                overallRatings={
                                  userProfileInfo?.candidate_profile_details &&
                                  userProfileInfo.candidate_profile_details
                                    ?.skills &&
                                  getRating(
                                    userProfileInfo?.candidate_profile_details &&
                                    userProfileInfo.candidate_profile_details
                                      ?.skills
                                  )
                                }
                              />
                            </div>
                          </Tab>

                          <Tab eventKey="Resume" title="Resume">
                            <div className="tab-inner pt-4 px-lg-4 bg-grey-3 d-flex justify-content-center">
                              {userProfileInfo?.candidate_profile_details &&
                                userProfileInfo.candidate_profile_details
                                  ?.user_details &&
                                userProfileInfo.candidate_profile_details
                                  .user_details?.user_meta_info &&
                                userProfileInfo.candidate_profile_details
                                  .user_details.user_meta_info?.resume ===
                                null ? (
                                <img
                                  src="/assets/images/resume-template.png"
                                  className="w-100"
                                  alt="resume template"
                                />
                              ) : (
                                <div className="bg-white border border-radius-10 p-4 w-100">
                                  <div className="text-right">
                                    <a
                                      className="btn btn-light mb-3"
                                      href={`${userProfileInfo?.candidate_profile_details &&
                                        userProfileInfo
                                          .candidate_profile_details
                                          ?.user_details &&
                                        userProfileInfo
                                          .candidate_profile_details
                                          .user_details?.user_meta_info &&
                                        userProfileInfo
                                          .candidate_profile_details
                                          .user_details.user_meta_info?.resume
                                        }`}
                                      download
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      <FontAwesomeIcon
                                        icon={faCloudArrowDown}
                                        className="mr-2"
                                      />
                                      Download
                                    </a>
                                  </div>
                                  <CustomPdfViewer
                                    file={
                                      userProfileInfo?.candidate_profile_details &&
                                      userProfileInfo.candidate_profile_details
                                        ?.user_details &&
                                      userProfileInfo.candidate_profile_details
                                        .user_details?.user_meta_info &&
                                      userProfileInfo.candidate_profile_details
                                        .user_details.user_meta_info?.resume
                                    }
                                  />
                                </div>
                              )}
                            </div>
                          </Tab>
                          <Tab
                            eventKey="ApplicantProfile"
                            title="Applicant Profile"
                          >
                            <div className="tab-inner pt-4 px-lg-4 bg-grey-3">
                              <ApplicantProfile />
                            </div>
                          </Tab>
                        </Tabs>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        <Modal
          show={scheduleInterviewModal}
          centered
          size="xl"
          onHide={onScheduleInterviewClick}
          className="common-modal apply-job-modal schedule-interview-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>Schedule Interview</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-3 bg-white">
            <div className="event-list">
              {Array.isArray(calendarEventLists) &&
                calendarEventLists.length > 0 ? (
                <>
                  {Array.isArray(calendarEventLists) &&
                    calendarEventLists.map((item) => (
                      <>
                        <div
                          className="event-box  mb-3 d-flex align-items-start justify-content-between"
                          ref={setLastElement}
                          key={item?.id}
                        >
                          <div className="content">
                            <h3
                              className="font-weight-semi mb-2 text-primary cursor"
                              onClick={() => onEventEditClick(item?.id)}
                            >
                              {item?.title}
                            </h3>
                            <p className="text-grey-4">
                              Estimated time: {item?.duration} mins | One to One
                              Interview
                            </p>
                          </div>
                          <div className="action">
                            <button
                              className={`btn btn-primary`}
                              onClick={() => onAssignInterviewEventClick(item)}
                            >
                              Assign
                            </button>
                          </div>
                        </div>
                      </>
                    ))}
                </>
              ) : (
                <div className="d-flex justify-content-between align-items-center">
                  <p>
                    No events created. Please create an event in your calendar.
                  </p>
                  <button
                    className="btn btn-primary"
                    onClick={onCreateEventClick}
                  >
                    Create Event
                  </button>
                </div>
              )}
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </MainLayout>
  );
};
